<template>
  <div class="contract-type-spec-detail-page">
    <div class="figma-white-card">
      <!-- 面包屑标题 -->
      <div class="figma-page-title-bar">
        <div class="figma-page-title">
          <span class="title-light cursor-pointer" @click="handleBackToList">{{ $t('committeeContractType.pageTitle') }}</span>
          <span class="title-arrow">&gt;</span>
          <span class="title-dark">{{ $t('committeeContractType.specDetail.title') }}</span>
        </div>

      </div>

      <!-- 工具栏 -->
      <div class="figma-toolbar-row">
        <div class="figma-btn-group">
          <el-button size="small" class="figma-btn figma-btn-primary" @click="handleAdd">
            <i class="el-icon-plus"></i>{{ $t('common.add') }}
          </el-button>
          <el-button size="small" class="figma-btn-refresh" :title="$t('common.refresh')" @click="getList">
            <i class="el-icon-refresh-right"></i>
          </el-button>
        </div>
        <div class="figma-search-group">
          <el-input
            v-model="searchForm.specCd"
            size="small"
            :placeholder="$t('contractTypeSpecManage.search.specCd')"
            class="figma-search-input"
            clearable
            @keyup.enter.native="handleSearch"
          />
          <el-input
            v-model="searchForm.specName"
            size="small"
            :placeholder="$t('contractTypeSpecManage.search.specName')"
            class="figma-search-input"
            clearable
            @keyup.enter.native="handleSearch"
          />
          <el-select
            v-model="searchForm.specShow"
            size="small"
            :placeholder="$t('contractTypeSpecManage.search.specShow')"
            class="figma-search-select"
            clearable
            @change="handleSearch"
          >
            <el-option :label="$t('contractTypeSpecManage.search.all')" value="" />
            <el-option :label="$t('contractTypeSpecManage.search.yes')" value="Y" />
            <el-option :label="$t('contractTypeSpecManage.search.no')" value="N" />
          </el-select>
          <el-button size="small" class="figma-btn-search" @click="handleSearch">
            <i class="el-icon-search"></i>
            <span>{{ $t('common.search') }}</span>
          </el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div class="figma-table-section">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="specCd" :label="$t('contractTypeSpecManage.table.specCd')" width="286" show-overflow-tooltip />
          <el-table-column prop="specName" :label="$t('contractTypeSpecManage.table.specName')" width="250" show-overflow-tooltip />
          <el-table-column :label="$t('contractTypeSpecManage.table.required')" width="146">
            <template slot-scope="scope">
              {{ scope.row.required === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.specShow')" width="158">
            <template slot-scope="scope">
              {{ scope.row.specShow === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.specValueType')" width="158">
            <template slot-scope="scope">
              {{ formatSpecValueType(scope.row.specValueType) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.specType')" width="224">
            <template slot-scope="scope">
              {{ formatSpecType(scope.row.specType) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.listShow')" width="192">
            <template slot-scope="scope">
              {{ scope.row.listShow === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.operation')" width="166">
            <template slot-scope="scope">
              <div class="action-links">
                <a class="action-link" @click="handleEdit(scope.row)">{{ $t('common.edit') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.row"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
        <el-select v-model="pagination.row" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <!-- 添加/编辑/删除弹窗组件 -->
    <add-contract-type-spec ref="addDialog" @success="handleSuccess" />
    <edit-contract-type-spec ref="editDialog" @success="handleSuccess" />
    <delete-contract-type-spec ref="deleteDialog" @success="handleSuccess" />
  </div>
</template>

<script>
import { queryContractTypeSpec } from '@/api/contract/contractTypeSpecManageApi'
import AddContractTypeSpec from '@/components/contract/addContractTypeSpec'
import EditContractTypeSpec from '@/components/contract/editContractTypeSpec'
import DeleteContractTypeSpec from '@/components/contract/deleteContractTypeSpec'

export default {
  name: 'CommitteeContractTypeSpecDetail',
  components: {
    AddContractTypeSpec,
    EditContractTypeSpec,
    DeleteContractTypeSpec
  },
  data() {
    return {
      loading: false,
      searchForm: {
        specCd: '',
        specName: '',
        specShow: '',
        contractTypeId: this.$route.query.contractTypeId || ''
      },
      tableData: [],
      pagination: {
        page: 1,
        row: 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px', padding: '0', textAlign: 'left' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', padding: '0', fontWeight: rowIndex % 2 === 1 ? '500' : '400', textAlign: 'left' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          row: this.pagination.row
        }
        const { data, total } = await queryContractTypeSpec(params)
        this.tableData = data || []
        this.pagination.total = total || 0
      } catch (error) {
        this.$message.error(this.$t('contractTypeSpecManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.getList()
    },
    handleSizeChange(size) {
      this.pagination.row = size
      this.pagination.page = 1
      this.getList()
    },
    handleAdd() {
      this.$refs.addDialog.open({
        contractTypeId: this.searchForm.contractTypeId
      })
    },
    handleEdit(row) {
      this.$refs.editDialog.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteDialog.open(row)
    },
    handleSuccess() {
      this.getList()
    },
    handleBackToList() {
      this.$router.push('/pages/committee/contractType')
    },
    formatSpecValueType(type) {
      const map = {
        '1001': this.$t('contractTypeSpecManage.specValueType.string'),
        '2002': this.$t('contractTypeSpecManage.specValueType.integer'),
        '3003': this.$t('contractTypeSpecManage.specValueType.amount'),
        '4004': this.$t('contractTypeSpecManage.specValueType.date'),
        '5005': this.$t('contractTypeSpecManage.specValueType.time')
      }
      return map[type] || type
    },
    formatSpecType(type) {
      const map = {
        '2233': this.$t('contractTypeSpecManage.specType.input'),
        '3344': this.$t('contractTypeSpecManage.specType.select')
      }
      return map[type] || type
    }
  }
}
</script>

<style scoped>
.contract-type-spec-detail-page {
  height: calc(100vh - 60px);
  background: #EBF2FA;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.figma-white-card {
  background: white;
  border-radius: 0 0 12px 12px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 页面标题 */
.figma-page-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 0;
  flex-shrink: 0;
}

.figma-page-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
  line-height: 22px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-light {
  color: #8C9BB4;
}

.title-dark {
  color: #1D2129;
}

.title-arrow {
  font-size: 14px;
  color: #8C9BB4;
  font-weight: 400;
}

.figma-btn-back {
  width: 78px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px solid #0E76FF !important;
  color: #0E76FF !important;
  background: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
}

/* 工具栏 */
.figma-toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 12px;
  flex-shrink: 0;
}

.figma-btn-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.figma-btn {
  height: 38px;
  min-width: 82px;
  border-radius: 10px !important;
  border: none !important;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.figma-btn i {
  margin-right: 6px;
}

.figma-btn-primary {
  background: #0E76FF !important;
}

.figma-btn-refresh {
  height: 38px;
  width: 38px;
  border-radius: 10px !important;
  border: 1px solid #DCE6F5 !important;
  background: white !important;
  color: #6A7282 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.figma-btn-refresh:hover {
  border-color: #0E76FF !important;
  color: #0E76FF !important;
}

.figma-search-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.figma-search-input {
  width: 256px;
  height: 38px;
}

.figma-search-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
  color: #1D2129;
}

.figma-search-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-search-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-search-select {
  width: 256px;
  height: 38px;
}

.figma-search-select >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
  color: #1D2129;
}

.figma-search-select >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-search-select >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-btn-search {
  width: 84px;
  height: 38px;
  border-radius: 10px !important;
  border: none !important;
  outline: 1px #0E76FF solid !important;
  outline-offset: -1px;
  color: #0E76FF !important;
  background: white !important;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.figma-btn-search:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

/* 表格 */
.figma-table-section {
  flex: 1;
  min-height: 0;
  padding: 12px 24px 0;
  overflow: auto;
}

.figma-table-section >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.figma-table-section >>> .el-table::before {
  display: none;
}

.figma-table-section >>> .el-table__header th {
  background: #EBF2FA !important;
  border: none !important;
}

.figma-table-section >>> .el-table__body td {
  border: none !important;
}

.figma-table-section >>> .el-table th .cell,
.figma-table-section >>> .el-table td .cell {
  padding-left: 24px;
  padding-right: 24px;
  line-height: 22px;
  text-align: left;
}

/* 操作链接 */
.action-links {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}

.action-link {
  color: #0E76FF;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
}

.action-link:hover {
  opacity: 0.85;
}

.link-space {
  width: 12px;
  display: inline-block;
}

/* 分页 */
.figma-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px 24px;
  gap: 8px;
  flex-shrink: 0;
}

.pagination-total {
  font-size: 14px;
  color: #1D2129;
  margin-right: 4px;
}

.figma-pagination >>> .el-pagination {
  display: flex;
  align-items: center;
  padding: 0;
}

.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next {
  width: 32px;
  height: 32px;
  border-radius: 2px;
  background: white;
}

.figma-pagination >>> .el-pager li {
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  color: #1D2129;
  font-weight: 600;
}

.figma-pagination >>> .el-pager li.active {
  background: #E8F3FF;
  color: #0E76FF;
}

.pagination-size-select {
  width: 92px;
  margin-left: 8px;
}

.pagination-size-select >>> .el-input__inner {
  height: 32px;
  border-radius: 8px;
  background: #F2F3F5;
  border: none;
  font-size: 14px;
  color: #1D2129;
}

@media (max-width: 1024px) {
  .figma-toolbar-row {
    align-items: flex-start;
    gap: 12px;
    flex-direction: column;
  }
  .figma-btn-group { flex-wrap: wrap; }
  .figma-search-group { width: 100%; margin-left: 0; flex-wrap: wrap; }
  .figma-search-input { width: min(256px, calc(100vw - 150px)); }
  .figma-search-select { width: min(256px, calc(100vw - 150px)); }
}
</style>
